/**
 * create-shared-worklist-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class CreateSharedWorklistRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CREATE_SHARED_WORKLIST;
  public static tag : MessageTag = MessageTag.REQ_CREATE_SHARED_WORKLIST;

  /**
   * Construct a new {@link CreateSharedWorklistRequest}.
   */
  constructor (
    public groupId : number,
    public title : string,
    public description : string,
    public stablePath? : string
  )
  {
    super();
  }

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_WATCHLIST);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/create-shared-worklist-request.ts